import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ThemeSwitcher } from "./components/ThemeSwitcher";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <a className="skip-link" href="#main">Skip to main content</a>
    <ThemeSwitcher />
    <App />
  </StrictMode>,
);
